<template>
    <v-card class="insurance-card" variant="outlined">
        <div>
            <v-img
                tile
                src="/insurance.jpg"
                :alt="product.name"
                height="200"
                lazy-src="/placeholder.png"
                eager
                gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                class="text-white align-end"
                @error="onImgError"
            >
                <template v-slot:placeholder>
                    <v-row
                        v-show="!imgError && product.mainImageUrl"
                        class="fill-height ma-0"
                        align="center"
                        justify="center"
                    >
                        <v-progress-circular indeterminate color="grey-lighten-5" />
                    </v-row>
                </template>
                <v-card-title>
                    <div class="d-flex flex-column" :title="product.name">
                        <span class="text-subtitle-2">
                            {{ product.name }}
                        </span>
                    </div>
                </v-card-title>
            </v-img>
            <div class="ma-2 flex-grow-1 flex-shrink-1">
                <div v-if="product.shortDescription" v-html="product.shortDescription" />
            </div>
            <div class="ma-4 price-col flex-shrink-0 text-right">
                <slot name="price" :offer="product.offers[0]">
                    <template v-if="!minPriceOffer.soldOut">
                        <div data-cy="client-price" class="font-weight-medium">
                            {{ $t('from') }} {{ $filters.price(minPriceOffer.price) }}
                        </div>
                        <discount-label :price="product.offers[0].price" />
                        <commission-amount :commission="minPriceOffer.price.commission" />
                        <v-btn
                            variant="flat"
                            block
                            color="primary"
                            class="my-2"
                            @click="selectForBooking(product.offers[0])"
                        >
                            {{ $t('book') }}
                        </v-btn>
                    </template>
                </slot>
                <div class="text-primary cursor-pointer text-no-wrap" @click="expanded = !expanded">
                    <span>
                        {{ $t('tours.detailed_info') }}
                    </span>
                    <v-icon color="primary">
                        {{ expanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
                    </v-icon>
                </div>
            </div>
        </div>
        <v-expand-transition>
            <v-list v-if="expanded">
                <template v-for="(offer, index) in product.offers" :key="offer.offerKey">
                    <v-list-item :data-cy="`insurance-offer-card-${index}`" class="pa-4">
                        <div class="text-caption">
                            <div class="mb-1 font-weight-medium text-body-1 text-grey">
                                <v-icon size="small" class="mr-1 text-info">mdi-information-outline</v-icon>
                                {{ offer.planName }}
                            </div>
                            <div class="mb-1">
                                <span v-if="isAvailable">
                                    <v-icon :title="$t('available')" size="small" class="mr-2 text-success">
                                        mdi-checkbox-marked-circle
                                    </v-icon>
                                    <span class="text-success" v-text="$t('available')" />
                                </span>
                                <span v-else>
                                    <v-icon :title="$t('on_request')" size="small" class="mr-2 text-warning">
                                        mdi-alert-circle
                                    </v-icon>
                                    <span class="text-warning" v-text="$t('on_request')" />
                                </span>
                            </div>
                            <div>
                                <conditions-label
                                    v-if="offer"
                                    :offer-key="offer.offerKey"
                                    :price="offer.price"
                                    @conditions="showConditionsInfo(offer)"
                                />
                            </div>
                        </div>
                        <div class="price-col ms-auto">
                            <slot name="price" :offer="offer">
                                <template v-if="!offer.soldOut">
                                    <v-btn
                                        color="primary"
                                        block
                                        variant="flat"
                                        data-cy="client-price"
                                        class="my-2"
                                        @click="selectForBooking(offer)"
                                    >
                                        {{ $filters.price(offer.price) }}
                                    </v-btn>
                                    <div class="text-caption text--secondary">
                                        {{
                                            `${$t('for')} ${touristsTotal} ${$t('person', touristsTotal)},
                                         ${searchRequest.daysCount} ${$t('day', searchRequest.daysCount)}`
                                        }}
                                    </div>
                                    <commission-amount :commission="offer.price.commission" />
                                    <net-amount :search-request="searchRequest" :price="offer.price" />
                                </template>
                                <sold-out-modal v-else />
                            </slot>
                        </div>
                    </v-list-item>
                    <v-divider v-if="index !== product.offers.length - 1" :key="index" />
                </template>
            </v-list>
        </v-expand-transition>
    </v-card>
</template>

<script lang="ts">
    import {Component} from 'vue-facing-decorator'
    import {InsuranceOfferCard} from '@/components/insurance/search/offers/InsuranceOfferCard.vue'

    @Component({})
    export class InsuranceOfferCardMobile extends InsuranceOfferCard {}

    export default InsuranceOfferCardMobile
</script>

<style lang="scss" scoped>
    .insurance-card {
        border: none !important;
    }
</style>
